import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components
import SidebarNav from '../components/navigation/SidebarNavGrouped';

class Page extends Component {
  state = {
    isLoaded: false
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.remove('hero');
  }

  render() {

    return (
      <>
        <div className="about">
          <div className="container">
            <div className="row">

              <div className="col-9 contentCont">
                <h1 className="allCaps-off">ABOUT iLEARN</h1>
                <p>The mission of the Innovation, Learning Excellence, and Academic Resource Network (iLEARN) is to enhance student success through learning opportunities that strengthen scholarly skills, digital literacy, and leadership development.</p>

                <h2>iLEARN focuses on six main areas:</h2>
                <p><strong className="highlight">Academic Skills Enrichment:</strong> Learning opportunities that are designed to provide supplemental instruction / review sessions on topics covered in historically difficult courses. The focus of the sessions is to review content AND to provide strategies for effective studying and learning in these courses.</p>
                <p><strong className="highlight">Academic Success:</strong> Learning opportunities related to academic success strategies, such as study skills and time management.</p>
                <p><strong className="highlight">Clinical Innovation:</strong> Learning opportunities that increase access to campus technologies that enhance learning, and also expose students to emerging clinical innovations.</p>
                <p><strong className="highlight">Healthcare Leadership:</strong> Learning opportunities that expose students to leadership topics to enhance clinical skills development.</p>
                <p><strong className="highlight">Online Learning:</strong> Learning opportunities related to how to use Blackboard and online learning technologies, such as Kaltura, GoReact, and Mentimeter.</p>
                <p><strong className="highlight">Scholarly Skills:</strong> Learning opportunities that provide support and resources for scholarly skills, including research and writing.</p>

                <p>Have ideas for new workshops? Want to share your feedback about iLEARN? <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=If31YBj82Eu4VdWgKUvY3pOiAjo3wPtAsyfLoLHpvcZUMUlFQUFEMTdIVkhaSlRZMTdSVUpPRjVYVCQlQCN0PWcu" target="_blank" rel="noopener noreferrer">Let us know</a>! For additional information or questions, please contact <a href="mailto:ilearn@usa.edu">ilearn@usa.edu</a>.</p>
              </div>

              <div className="col-3 sideCont">
                <SidebarNav />
              </div>

            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Page;